import { publicInstance } from "../axios";

export const getSearchSuggestions = async (input) => {
  return await publicInstance
    .get(`search-auto-complete?searchKey=${input}`)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};
export const doSearchAction = async (input) => {
  return await publicInstance
    .post(`search`, { searchKey: input })
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};

export const getTrendingWord = async () => {
  return await publicInstance
    .get(`home/search-trending`)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};
